import { institutionalApi } from "./index";

export const healthcheckApi = institutionalApi.injectEndpoints({
  endpoints: (builder) => ({
    healthCheck: builder.query<string, void>({
      query: () => ({
        url: "/healthcheck/fe_version",
        method: "GET",
      }),
      providesTags: ["Healthcheck"],
    }),
  }),
});

export const { useHealthCheckQuery } = healthcheckApi;
